module.exports = __webpack_public_path__ + "static/media/best-price.fac73f74.svg";